<template>
    <i class="ico-svg-search">
        <svg v-bind="{ width, height }" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.796 12.023c2.008-3.598 1.614-7.699-1.45-10.27a7.444 7.444 0 00-10.282.657C-.662 5.35-.691 9.94 1.998 12.916c2.688 2.975 7.173 2.975 10.251.813l5.833 5.947c.444.437 1.15.431 1.586-.014a1.17 1.17 0 00.014-1.618l-5.886-6.02zM2.3 7.65a5.25 5.25 0 1110.5 0 5.25 5.25 0 01-10.5 0z" :fill="color"/>
        </svg>
    </i>
</template>

<script>
export default {
    name: 'IconSearch',

    props: {
        width: {
            type: Number,
            default: 20,
        },

        height: {
            type: Number,
            default: 20,
        },

        color: {
            type: String,
            default: 'currentColor',
        },
    },
};
</script>
